<div
  #bestPrice
  class="best-price-tooltip"
  [ngClass]="{
    'best-price-tooltip--visible': isVisibleState,
    'best-price-tooltip--last': isLastItem,
    'best-price-tooltip--right': position === 'right',
    'best-price-tooltip--left': position === 'left',
    'best-price-tooltip--centered': position === 'centered',
    'best-price-tooltip--right-centered': position === 'right-centered',
    'best-price-tooltip--banner': bannerType
  }"
>
  <span class="best-price-tooltip__title">
    {{ (checkinDate && checkoutDate ? 'best-price-tooltip-title' : 'best-price-tooltip-title-no-dates') | translate }}
  </span>

  <span class="best-price-tooltip__info">
    {{
      checkinDate && checkoutDate
        ? (checkinDate | formatDate: 'dd' : currentLang) +
          '-' +
          (checkoutDate | formatDate: 'dd LLL yyyy' : currentLang)
        : ''
    }}
    {{ checkinDate && checkoutDate ? '・' : '' }}
    <span *ngIf="!checkinDate || !checkoutDate">--/--/-- </span>

    <span class="best-price-tooltip__info-guests">
      {{ adults | pluralize: 'adult' : 'adults'
      }}<ng-container *ngIf="children && children > 0">{{ ',' }}</ng-container>
      <ng-container *ngIf="children && children > 0">
        {{ children | pluralize: 'child' : 'children' }}
      </ng-container>
    </span>
  </span>

  <button
    *ngIf="!checkinDate || !checkoutDate"
    id="qa-best-price-tooltip-select-dates"
    sparkButton
    type="button"
    class="w-full !normal-case"
    background="outline"
    (click)="handleScrollToDatePicker()"
  >
    {{ 'best-price-tooltip-select-dates' | translate }}
    <span class="svg-inline--fa fa fa-calendar-plus"></span>
  </button>
  <span *ngIf="checkinDate && checkoutDate" class="best-price-tooltip__main">
    <span class="font-bold">Limehome</span>
    <span>
      <ng-template [ngTemplateOutlet]="price" [ngTemplateOutletContext]="{ rate: 1, from: true }"></ng-template>
    </span>
  </span>

  <ul class="best-price-tooltip__list">
    <li class="px-sm py-xs flex justify-between items-center">
      <span>Booking.com</span>
      <span class="font-bold">
        <ng-template
          [ngTemplateOutlet]="price"
          [ngTemplateOutletContext]="{ rate: bestPriceRates.bookingComRate }"
        ></ng-template>
      </span>
    </li>
    <li class="px-sm py-xs flex justify-between items-center">
      <span>Expedia.com</span>
      <span class="font-bold">
        <ng-template
          [ngTemplateOutlet]="price"
          [ngTemplateOutletContext]="{ rate: bestPriceRates.expediaRate }"
        ></ng-template>
      </span>
    </li>
    <li class="px-sm py-xs flex justify-between items-center">
      <span>Airbnb</span>
      <span class="font-bold">
        <ng-template
          [ngTemplateOutlet]="price"
          [ngTemplateOutletContext]="{ rate: bestPriceRates.airbnbRate }"
        ></ng-template>
      </span>
    </li>
  </ul>
</div>

<ng-template #price let-rate="rate" let-from="from">
  @if (amount) {
    @if (from) {
      <span class="font-regular">{{ 'suite-price-from' | translate | lowercase }}</span>
    }
    <span class="font-bold">
      {{
        (currencies.currencySymbol[currency] | translate) +
          (bookingLengthInDays < suiteFilterLimitInDays
            ? (math.round(amount / bookingLengthInDays / rate) | number: '1.0-0')
            : (math.round(((amount / bookingLengthInDays) * suiteFilterLimitInDays) / rate) | number: '1.0-0'))
      }}
    </span>
  } @else {
    -
  }
</ng-template>
